
import moment from 'moment'
import { BigOrder } from 'src/core/models/'
import type { ColumnsType } from 'antd/lib/table'
import {
  CustomHeaderText,
  CustomTotalColumn,
  CustomStatusColumn,
  OrderItemMovileViewColumn,
} from 'src/components'

const MyOrdersListColumns: ColumnsType<BigOrder> = [
  {
    title: () => <CustomHeaderText text={'developers.Date'} />,
    responsive: ['sm'],
    className: 'pointer-cursor',
    sorter: (a: BigOrder, b: BigOrder) => {
      const dateA = new Date(a.order.created)
      const dateB = new Date(b.order.created)
      return dateA.getTime() - dateB.getTime()
    },
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => <div style={{ marginTop: '8px' }}>
      <strong>{moment(record.order.created).format('MMMM D, h:mm')}</strong>
    </div>
  },
  {
    title: () => <CustomHeaderText text={'Summary.Reference'} />,
    responsive: ['sm'],
    className: 'pointer-cursor',
    sorter: (a: BigOrder, b: BigOrder) => {
      return a.order.reference.length - b.order.reference.length
    },
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => <div style={{ marginTop: '8px' }}>
      <strong>{record.order.reference}</strong>
    </div>
  },
  {
    title: () => <CustomHeaderText text={'Summary.Total'} isCentered />,
    responsive: ['sm'],
    className: 'pointer-cursor',
    sorter: (a: BigOrder, b: BigOrder) => a.order.total - b.order.total,
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => <CustomTotalColumn total={record.order.total} isStrong={true} />
  },
  {
    title: () => <CustomHeaderText text={'Summary.Status'} isCentered />,
    responsive: ['sm'],
    className: 'pointer-cursor',
    render: (_, record) => <div className='centered-div' style={{ marginTop: '8px' }}>
      <CustomStatusColumn
        isStatusOk={record.order.status === 'paid'}
        isCancelled={record.order.is_cancelled}
      />
    </div>
  },

  // Mobile
  {
    title: () => <CustomHeaderText text={'Transactions.MyOrders'} />,
    responsive: ['xs'],
    className: 'pointer-cursor',
    sorter: (a: BigOrder, b: BigOrder) => {
      const dateA = new Date(a.order.created)
      const dateB = new Date(b.order.created)
      return dateA.getTime() - dateB.getTime()
    },
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => <OrderItemMovileViewColumn bigOrder={record} />
  }
]

export default MyOrdersListColumns
